import { createAction, handleActions } from 'redux-actions';

const initialState = {
  loading: false,
  tableData: []
};

export const setTableData = createAction('SET_TABLE_DATA');
export const setTableMetaData = createAction('SET_TABLE_META_DATA');

export const toggleTableLoading = createAction('SET_TABLE_LOADING');

export const resetTable = createAction('RESET_TABLE');

export const changeTableHeader = createAction('CHANGE_TABLE_HEADER');

const getUpdatedHeaders = (payload, existingHeaders) => ({
  ...existingHeaders,
  [payload.prop]: payload.value
});

export default handleActions({
  [resetTable]: () => ({
    ...initialState
  }),
  [setTableData]: (state, action) => ({
    ...state,
    tableData: action.payload
  }),
  [setTableMetaData]: (state, { payload }) => ({
    ...state,
    source: payload.source,
    resource: payload.resource,
    startDate: payload.startDate,
    endDate: payload.endDate,
    queryId: payload.queryId
  }),
  [toggleTableLoading]: (state, {payload}) => ({
    ...state,
    loading: payload
  }),
  [changeTableHeader]: ({tableData: [headers, ...tableData], ...state}, { payload }) => ({
    ...state,
    tableData: [
      getUpdatedHeaders(payload, headers),
      ...tableData
    ]
  })
}, initialState);
